<script setup lang="ts">
import { ref, onMounted, nextTick, provide } from 'vue';
import { defineAsyncComponent } from 'vue';
import type { ImageServiceInt, ImageDataInt, LayerServiceInt } from '@ts/imageDataInt';

const backgroundContainer = defineAsyncComponent(() => import('@components/background.vue'));
const componentContainer = defineAsyncComponent(() => import('@components/component.vue'));

const browserType = ref<string>('desktop');

const imageData = ref<ImageDataInt>([{
    id: 0, image: '', mobile: '', text: ''
}]);
const imageService = ref<ImageServiceInt>({
    activeIndex : 0,
    displayBasic: false
});

const layerService = ref<LayerServiceInt>({
    layertype: [{id:'impressum'}],
    activeIndex : 0,
    displayBasic: false
});

function defineBrowserType() {
    switch(true) {
        case (window.innerWidth < 700):
            browserType.value = 'mobile';
        break;
        default:
            browserType.value = 'desktop';
        break;
    }
} 
//Mount
onMounted(() => {   
    nextTick(() => {
        window.addEventListener('load', () => {
            defineBrowserType();
        });
        window.addEventListener('resize', () => {
            defineBrowserType();
        });
        window.addEventListener('orientationChange', () => {
            defineBrowserType();
        });
    });
});

function changeImageData(newImageData:ImageDataInt) {
    imageData.value = [];
    imageData.value = newImageData;
}
function changeLayer(newLayerType:string) {
    console.log(newLayerType);
    layerService.value.layertype[0].id = newLayerType;
    layerService.value.displayBasic = true;
}
provide('changeImageData', changeImageData);
provide('changeLayer', changeLayer);
</script>

<template lang="pug">
.mainContainer
    backgroundContainer
    componentContainer(
        :browserType="browserType"
        :imageData="imageData"
        :imageService="imageService"
        :layerService="layerService"
    )
</template>
